import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectNameLink: {
		id: 'issue-navigator-custom-filters.common.details-popup.project-grant.project-name-link',
		defaultMessage: 'Project: {linkStart}{name}{linkEnd} (Everyone)',
		description: 'Text with project permission.',
	},
});
